export default "__VITE_ASSET__DuUWfBJ6__"